import { render, staticRenderFns } from "./ClinicQuotation.vue?vue&type=template&id=2e16f58c"
import script from "./ClinicQuotation.vue?vue&type=script&lang=js"
export * from "./ClinicQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports